import { render } from "./AssessmentRule.vue?vue&type=template&id=2af6b6b4&scoped=true"
import script from "./AssessmentRule.vue?vue&type=script&lang=js"
export * from "./AssessmentRule.vue?vue&type=script&lang=js"

import "./AssessmentRule.vue?vue&type=style&index=0&id=2af6b6b4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af6b6b4"]])

export default __exports__